// Author Lin
// Date 2021-08-09 15:43:06

class SithMesMstProjectPlanTemplate {
        constructor({
                id = null,
                parentId = '',
                parentName = '',
                machineTypeId = '',
                level = '',
                activityId = '',
                name = '',
                chineseDescription = '',
                duration = '',
                predecesor = '',
                autoCaculate = '',
                milestoneCode = '',
                seq = '',
                type = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.parentId = parentId;
            this.parentName = parentName;
            this.machineTypeId = machineTypeId;
            this.level = level;
            this.activityId = activityId;
            this.name = name;
            this.chineseDescription = chineseDescription;
            this.duration = duration;
            this.predecesor = predecesor;
            this.autoCaculate = autoCaculate;
            this.milestoneCode = milestoneCode;
            this.seq = seq;
            this.type = type;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new SithMesMstProjectPlanTemplate();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'parentId',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.grid.parentId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'parentName',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.grid.parentName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'machineTypeId',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.grid.machineTypeId',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'machineName',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.grid.machineName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'level',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.grid.level',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'activityId',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.grid.activityId',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'name',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.grid.name',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'chineseDescription',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.grid.chineseDescription',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'duration',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.grid.duration',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'predecesor',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.grid.predecesor',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'autoCaculate',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.grid.autoCaculate',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'milestoneCode',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.grid.milestoneCode',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                },
                {
                key: 'seq',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.grid.seq',
                sortable: true,
                form: {
                type: 'inputNumber'
                }
                },
                {
                key: 'type',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.grid.type',
                sortable: true,
                form: {
                type: 'inputNumber'
                }
                }
            ])}
        
        const filter = {
            idFilter : "",
            idListFilter : "",
            machineTypeIdListFilter : "",
            parentIdFilter : "",
            parentNameFilter : "",
            machineTypeIdFilter : "",
            machineNameFilter : "",
            levelFilter : "",
            activityIdFilter : "",
            nameFilter : "",
            chineseDescriptionFilter : "",
            durationFilter : "",
            predecesorFilter : "",
            autoCaculateFilter : "",
            milestoneCodeFilter : "",
            seqFilter : "",
            typeFilter : ""
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'parentNameFilter',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.filter.parentName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'sithMesMstProjectPlanTemplate'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"parentId":"id"}'
                        }
                },
                {
                key: 'machineNameFilter',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.filter.machineName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'sithMesMstMachineType'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"machineTypeId":"id"}'
                        }
                },
                {
                key: 'levelFilter',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.filter.level',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'activityIdFilter',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.filter.activityId',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'nameFilter',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.filter.name',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'chineseDescriptionFilter',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.filter.chineseDescription',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'durationFilter',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.filter.duration',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'predecesorFilter',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.filter.predecesor',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'autoCaculateFilter',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.filter.autoCaculate',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'milestoneCodeFilter',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.filter.milestoneCode',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'seqFilter',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.filter.seq',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'typeFilter',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.filter.type',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                }
        ];
        
            const levelTreeFilterConfigs = [
                {
                        key: 'chineseDescriptionFilter',
                        label: 'label.sith.mst.sithMesMstProjectPlanTemplate.filter.chineseDescription',
                        disabled: false,
                        form: {
                        type: 'input'
                                }
                },
                {
                        key: 'machineNameFilter',
                        label: 'label.sith.mst.sithMesMstProjectPlanTemplate.filter.machineName',
                        disabled: false,
                        form: {
                        type: 'entityModalSelect'
                            ,entity: 'sithMesMstMachineType'
                            ,correspondingField: 'name'
                            ,fieldsBindingByEntityModalSelected: '{"machineTypeId":"id"}'
                                }
                },
            ];
        
            const entityFormConfigs = [
                {
                key: 'parentName',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.entity.parentName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'sithMesMstProjectPlanTemplate'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"parentId":"id"}'
                        }
                },
                {
                key: 'machineTypeId',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.entity.machineTypeId',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'sithMesMstMachineType'
                    ,correspondingField: 'id'
                        }
                },
                {
                key: 'level',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.entity.level',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'activityId',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.entity.activityId',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                    ,required: true
                        }
                },
                {
                key: 'name',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.entity.name',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                    ,required: true
                        }
                },
                {
                key: 'chineseDescription',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.entity.chineseDescription',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'duration',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.entity.duration',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                    ,required: true
                        }
                },
                {
                key: 'predecesor',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.entity.predecesor',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'autoCaculate',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.entity.autoCaculate',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'milestoneCode',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.entity.milestoneCode',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'seq',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.entity.seq',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'type',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.entity.type',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'remark',
                label: 'label.sith.mst.sithMesMstProjectPlanTemplate.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {SithMesMstProjectPlanTemplate, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs, levelTreeFilterConfigs
        
        
        }
        